
// src/pages/About.js

import React, { useEffect } from "react";
import "./about.css";

import aboutImage from "../assets/about.png";

import { setPageMeta } from "../utils/seo";

const About = () => {

  useEffect(() => {
    setPageMeta({
      title: "About Banat India | Trusted Oral Care Brand",
      description:
        "Learn about Banat India's mission to deliver quality toothbrushes and oral care for every age.",
      keywords:
        "about Banat India, oral care brand, toothbrush company, dental hygiene, premium toothbrushes",
    });
  }, []);

  return (
    <section className="about-section">

      {/* LEFT SIDE */}

      <div className="about-left">

        <span className="about-tag">
          ABOUT BANAT
        </span>

        <h2>
          Crafted For <br />
          Healthier Smiles
        </h2>

        <div className="about-line"></div>

        <p className="about-description">
          At <strong>Banat</strong>, we believe oral care should feel
          premium, effortless and modern. Our toothbrushes are thoughtfully
          designed for every age group — combining comfort, hygiene,
          innovation and elegant design.
        </p>

        <p className="about-description">
          From ultra-soft bristles for children to ergonomic precision
          for adults and seniors, every product is created using
          medically approved materials trusted by families worldwide.
        </p>

        {/* STATS */}

        <div className="about-stats">

          <div className="stat-card">
            <h3>25+</h3>
            <span>Countries</span>
          </div>

          <div className="stat-card">
            <h3>1M+</h3>
            <span>Happy Customers</span>
          </div>

          <div className="stat-card">
            <h3>100%</h3>
            <span>Premium Care</span>
          </div>

        </div>

      </div>

      {/* RIGHT SIDE */}

      <div className="about-right">

        <div className="about-image-card">

          <div className="floating-circle"></div>

          <img
            src={aboutImage}
            alt="Banat Premium Oral Care"
            className="about-image"
          />

        </div>

      </div>

    </section>
  );
};

export default About;

